import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import displayCounter from './displayCounter.js'

export default contract({
  displayCounter: array([
    displayCounter
  ]),
})
